var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.625C12.9264 17.4769 11.3831 19.0494 9.31564 18.9988C8.83464 18.9871 8.24014 18.8194 7.05112 18.484C4.18961 17.6769 1.70555 16.3204 1.10956 13.2816C1 12.723 1 12.0944 1 10.8373L1 9.16274C1 7.90561 1 7.27704 1.10956 6.71845C1.70555 3.67963 4.18961 2.32314 7.05112 1.516C8.24014 1.18062 8.83465 1.01293 9.31564 1.00116C11.3831 0.95058 12.9264 2.52305 13 4.37499",
    stroke: "#14181F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H19M8 10C8 9.29977 9.9943 7.99153 10.5 7.5M8 10C8 10.7002 9.9943 12.0085 10.5 12.5",
    stroke: "#14181F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconNew);
export default __webpack_public_path__ + "static/media/logout-icon-new.e8538820eb9e6acdd9c38da78f0dd93d.svg";
export { ForwardRef as ReactComponent };